"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
function IndicatorCustom() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                        backgroundColor: 'secondary.dark',
                        height: '16px',
                        width: '16px',
                        marginTop: '-16px',
                    } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            height: '16px',
                            width: '16px',
                            backgroundColor: 'white',
                            borderRadius: '0px 0px 20px 0px',
                            borderStyle: 'solid',
                            borderColor: 'secondary.light',
                            borderWidth: '0px',
                            borderRightWidth: '1px',
                            borderBottomWidth: '1px',
                        } }) })) })), (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                        backgroundColor: 'secondary.dark',
                        height: '16px',
                        width: '16px',
                        marginTop: '70px',
                    } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            height: '16px',
                            width: '16px',
                            backgroundColor: 'white',
                            borderRadius: '0px 20px 0px 0px',
                            borderStyle: 'solid',
                            borderColor: 'secondary.light',
                            borderWidth: '0px',
                            borderRightWidth: '1px',
                            borderTopWidth: '1px',
                        } }) })) }))] }));
}
function SlideMenu(_a) {
    var menuItems = _a.menuItems, selectedMenu = _a.selectedMenu, onChange = _a.onChange, icon = _a.icon;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
            width: {
                xs: '227px',
                xl: '280px',
            },
            zIndex: 2,
            marginRight: '-1px',
        } }, { children: (0, jsx_runtime_1.jsx)(material_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: selectedMenu, onChange: onChange, "aria-label": "Vertical tabs example", sx: {
                backgroundColor: 'transparent',
                paddingTop: '12px',
                paddingBottom: '16px',
                '& .MuiTabs-indicator': {
                    backgroundColor: 'secondary.dark',
                    width: {
                        xs: '227px',
                        xl: '280px',
                    },
                    zIndex: 2,
                    borderRadius: '20px 0px 0px 20px',
                    borderStyle: 'solid',
                    borderColor: 'secondary.light',
                    borderWidth: '1px',
                    borderRightWidth: '0px',
                },
            }, TabIndicatorProps: {
                children: (0, jsx_runtime_1.jsx)(IndicatorCustom, {}),
            } }, { children: menuItems.map(function (item, index) {
                return ((0, jsx_runtime_1.jsx)(material_1.Tab, { icon: icon, disableRipple: true, label: item.label, id: "popinitem".concat(item.value), sx: {
                        marginTop: index === 0 ? '16px' : '0px',
                        marginBottom: index === menuItems.length - 1 ? '16px' : '0px',
                        height: '54.4px',
                        color: 'text.primary',
                        textTransform: 'none',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        zIndex: 3,
                        '&.Mui-selected': {
                            fontWeight: 'bold',
                            color: 'text.primary',
                        },
                    }, disabled: item.disabled }, "popinitem".concat(item.value)));
            }) })) })));
}
exports.default = SlideMenu;
SlideMenu.defaultProps = {
    icon: undefined,
};
//# sourceMappingURL=SlideMenu.js.map